import styled from "styled-components";
import {
  FaCog,
  FaPhoneSlash,
  FaMicrophone,
  FaMicrophoneSlash,
  FaVideo,
  FaVideoSlash,
} from "react-icons/fa";
import { Avatar } from "./Avatar";
import { useAuth } from "../providers/AuthProvider";
import { useWebRTC } from "../providers/WebRTCProvider";
import { useState } from "react";
import ProfileModal from "./ProfileModal";
import IconContainer from "./IconContainer";
import Tab from "./Tab";
import ListWrapper from "./ListWrapper";
import { colors } from "../styles/theme";

const VideoChatWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ConnectedText = styled.p`
  color: ${colors.green};
  font-weight: bold;
`;

const ProfileTab = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const {
    callId,
    hangUp,
    audioActive,
    videoActive,
    setAudioActive,
    setVideoActive,
  } = useWebRTC();

  return (
    <div>
      <ListWrapper withSpacers={true}>
        <Tab
          name={user.database.username}
          avatarProps={{
            imageSrc: user.database.photoURL,
            showStatus: true,
            online: true,
          }}
          icons={[{ iconComponent: FaCog, onClick: () => setIsOpen(true) }]}
        />
        {callId && (
          <VideoChatWrapper>
            <ConnectedText>Connected</ConnectedText>
            <IconContainer
              icons={[
                {
                  iconComponent: audioActive ? FaMicrophone : FaMicrophoneSlash,
                  onClick: async () => setAudioActive(!audioActive),
                },
                {
                  iconComponent: videoActive ? FaVideo : FaVideoSlash,
                  onClick: async () => setVideoActive(!videoActive),
                },
                {
                  iconComponent: FaPhoneSlash,
                  onClick: async () => {
                    await hangUp();
                  },
                },
              ]}
            />
          </VideoChatWrapper>
        )}
      </ListWrapper>
      <ProfileModal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} />
    </div>
  );
};

export default ProfileTab;
